//配置全局访问接口地址
// 测试地址
// const commonUrl = "http://cswrite.fzbykj.com";
// const fileUploadUrl = "http://cswrite.fzbykj.com/FjSUPmONcn.php/ajax/upload";
// const fileUploadUrl = "http://cswrite.fzbykj.com/addons/alioss/index/upload";

// 正式地址
const commonUrl = "https://fz.npdhwh.com";
const fileUploadUrl = "https://fz.npdhwh.com/FjSUPmONcn.php/ajax/upload"

// const commonUrl = "https://npdhwh.fzbykj.com";
// const commonUrl = "http://hd.com/";
// const fileUploadUrl = "https://npdhwh.fzbykj.com/FjSUPmONcn.php/ajax/upload";

// const fileUploadUrl = "https://npdhwh.fzbykj.com/addons/alioss/index/params";

// 本地地址
// const commonUrl = "192.168.88.122";
// const fileUploadUrl = "192.168.88.122/FjSUPmONcn.php/ajax/upload";

export default {
  commonUrl,
  fileUploadUrl
};



// WEBPACK FOOTER //
// ./src/global/index.js